module.exports = __webpack_public_path__ + "img/medical-product.e0138443.svg";